import React, { Component, useState } from 'react';
import $ from 'jquery';
import axios from "axios";
import { setCookie, getCookie, loginUrl, login_check } from './Common';

class SecToday extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: null,       // JSON 데이터를 저장할 곳
      loading: true,    // 로딩 상태
      error: null,       // 에러 메시지 저장
      uzzim: false,
      hasExecuted: false
    };
  }

  async componentDidMount() {
    const isLogin = await login_check();

    const publicUrl = process.env.PUBLIC_URL;
    const getToday = () => {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    try {
      const response = await axios.get(publicUrl + '/api/getTodayWord.php');
      if (response.data.uzzim) {
        $("#svgZzim").attr("fill-opacity", 1);
        $('#zzimbtn').addClass('active');
      }
      const pocketTodayMain = getCookie('pocketTodayMain');
      if (pocketTodayMain == 'act' || response?.data.todayact == getToday()) {
        $('.today-word-main').addClass('active');
        $('.today-word-main').find('.txt').css('opacity', '0');
      }
      this.setState({
        data: response.data,   // JSON 전체를 저장
        loading: false,
        uzzim: response.data.uzzim
      });
    } catch (error) {
      this.setState({
        error: error.message,
        loading: false
      });
    };
    //
    /*
    $('.today-word-main').each(function () {
      const $this = $(this);
      $this.find('.card-wrap').on('click', function () {
        if (!this.state.hasExecuted) {
          setCookie('pocketTodayMain', 'act');
          const setActRes = axios.get('/api/setTodayAct.php');
          console.log(setActRes.data);
        }
        $(this).parent().addClass('active');
        $(this).parent().find('.txt').css('opacity', '0');
        this.setState({ hasExecuted: true });
      });
    });
*/

  }
  handleCardClick = (e) => {
    // 이미 실행된 경우 함수 종료

    if (!this.state.hasExecuted) {
      // setCookie와 axios 요청 한 번만 실행
      setCookie('pocketTodayMain', 'act');

      axios.get('/api/setTodayAct.php')
        .then(response => {
          console.log(response.data);
        })
        .catch(error => {
          console.error('Error:', error);
        });
    }
    // 실행 후 상태 업데이트 (한 번만 실행되도록)
    this.setState({ hasExecuted: true });

    // UI 변경 (클릭 후 처리)
    const parent = e.target.closest('.card-wrap').parentElement;
    parent.classList.add('active');
    parent.querySelector('.txt').style.opacity = '0';
  };
  handleButtonClick = async (idx) => {
    const element = document.getElementById(`zzimbtn`);
    const isActive = this.state.uzzim;

    let md = 'setZzim';
    if (isActive) {
      md = 'unsetZzim';
    }

    try {
      const ret = await setWord(md, idx);

      if (ret == 'setZzim') {
        element.className = 'zzim active';
        $("#svgZzim").attr("fill-opacity", 1);
        $('#zzimbtn').addClass('active');
        this.setState({ uzzim: true });
      } else {
        $("#svgZzim").attr("fill-opacity", 0);
        $('#zzimbtn').removeClass('active');
        element.className = 'zzim';
        this.setState({ uzzim: false });
      }
      /*
      const res = await axios.post('/api/update', { id });

      // 응답에 따라 visible 상태를 업데이트
      this.setState((prevState) => ({
        dataList: prevState.dataList.map((item) =>
          item.id === id ? { ...item, visible: res.data.newVisible } : item
        )
      }));
      */
    } catch (err) {
      console.error('버튼 클릭 처리 실패:', err);
    }
  };
  //
  render() {
    const { data, loading, error } = this.state;
    return (
      <section className="section section--today">
        <div className="title-bx">
          <h1 className="tit"> 오늘의 용어 </h1>
          <p className="desc">랜덤 카드 한 장, 오늘 배울 용어는?</p>
        </div>
        <></>
        <div className="today-word-main" data-aos="fade-in">
          <div className="card-wrap" onClick={this.handleCardClick}>
            <div className="card card--1"></div>
            <div className="card card--2"></div>
            <div className="card card--3">
              <div class="card--front"></div>
              <div className="card--back">
                <article className="word-card">
                  <button type="button" id='zzimbtn' className="zzim" onClick={() => this.handleButtonClick(data.idx)}>
                    <svg id="svgZzim" width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" fillOpacity="0">
                      <use xlinkHref="#zzim"></use>
                    </svg>
                    <span className="sr-only">찜하기</span>
                  </button>
                  <p className="tit">{data?.title}</p>
                  <p className="eng">{data?.subtitle}</p>
                  <p className="desc">{data?.description}</p>
                  <a href={data ? `/View/${data.idx}` : "#"} className="btn">용어 자세히 보기</a>
                </article>
              </div>
            </div>
          </div>
          <p className="txt">카드를 클릭해 보세요!</p>
        </div>
      </section>
    );
  }
}


function userZzim(idx) {
  //const uzzim =
  let uz_fillopacity = $("#svgZzim").attr("fill-opacity");
  let md;
  if (uz_fillopacity == 0) {
    $("#svgZzim").attr("fill-opacity", 1);
    md = 'setZzim';
  } else {
    $("#svgZzim").attr("fill-opacity", 0);
    md = 'unsetZzim';
  }
  setWord(md, idx);
}

async function setWord(md, idx) {

  const publicUrl = process.env.REACT_APP_POCKET_WWW;
  setCookie('JUMP_URI', publicUrl);

  try {
    const response = await axios.get(publicUrl + '/api/setWord.php?md=' + md + '&idx=' + idx);
    if (response.data == 'NO') {
      const refUrl = process.env.REACT_APP_USER_WWW + '/snslogin/PocketLogingDone.php?loc=&idx=' + idx;
      window.location.href = loginUrl + '?ref=' + encodeURIComponent(refUrl);
    }

    return response.data;
  } catch (error) {
    console.log(error.message);
    return false;
  };
}
export default SecToday;      